import { useEffect, useCallback } from "react";

interface ToastProps {
  message: string;
  type?: "success" | "error";
  visible: boolean;
  onClose: () => void;
}

export default function Toast({ message, type = "success", visible, onClose }: ToastProps) {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(handleClose, 4000);
    return () => clearTimeout(timer);
  }, [visible, handleClose]);

  const bgColor = type === "success"
    ? "bg-emerald-500"
    : "bg-red-500";

  const icon = type === "success"
    ? "ri-check-line"
    : "ri-close-line";

  return (
    <div
      className={`fixed top-6 left-1/2 z-50 flex items-center gap-3 px-5 py-3.5 rounded-xl bg-white border border-black/5 min-w-[320px] max-w-[480px] transition-all duration-300 ease-out -translate-x-1/2 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 -translate-y-4 pointer-events-none"
      }`}
      role="alert"
    >
      <div className={`w-8 h-8 flex items-center justify-center rounded-full ${bgColor} shrink-0`}>
        <i className={`${icon} text-white text-sm`}></i>
      </div>
      <p className="text-stone-800 text-sm font-medium flex-1 leading-snug">{message}</p>
      <button
        type="button"
        onClick={handleClose}
        className="w-6 h-6 flex items-center justify-center rounded-full hover:bg-stone-100 transition-colors cursor-pointer shrink-0"
        aria-label="Закрыть уведомление"
      >
        <i className="ri-close-line text-stone-600 text-sm"></i>
      </button>
    </div>
  );
}